"use client";

import React from "react";
import { Clock, Plane, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Airport Transfers",
  description: "Seamless and punctual transportation to and from all major airports. Experience stress-free travel with our dedicated chauffeurs tracking your flight status.",
  icon: Plane,
  link: "/OnlineBookingPage"
}, {
  title: "VIP Transportation",
  description: "Exclusive luxury vehicles for executives, celebrities, and VIPs requiring the highest level of privacy, comfort, and uncompromising security.",
  icon: Star,
  link: "/OnlineBookingPage"
}, {
  title: "Hourly Bookings",
  description: "Flexible, on-demand chauffeur service tailored to your exact schedule. Perfect for multi-stop corporate meetings, shopping trips, or personalized city tours.",
  icon: Clock,
  link: "/OnlineBookingPage"
}];
function ServiceCard({
  service,
  index
}: {
  service: typeof services[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div ref={ref} data-index={index} className={`bg-black/40 backdrop-blur-[12px] border-t-2 border-t-primary rounded-lg p-8 flex flex-col items-start text-left transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="mb-6 p-4 bg-white/5 rounded-full border border-white/10">
        <service.icon className="w-6 h-6 text-white" strokeWidth={1.5} />
      </div>
      <h3 className="font-display text-white text-2xl font-semibold mb-4 tracking-tight">
        {service.title}
      </h3>
      <p className="font-sans text-[hsl(0,0%,90%)] leading-relaxed mb-8 flex-grow">
        {service.description}
      </p>
      <Button asChild className="btn-secondary w-full sm:w-auto mt-auto">
        <Link to={service.link}>Reserve Now</Link>
      </Button>
    </div>;
}
export default function OurPremiumServices() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="our-premium-services" className="bg-dark-section text-dark-foreground section-padding relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/10 blur-[100px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Our Premium Services
          </h2>
          <p className="font-sans text-[hsl(0,0%,90%)] text-lg md:text-xl leading-relaxed">
            Experience the pinnacle of luxury transportation with our tailored services designed to meet and exceed your highest expectations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {services.map((service, index) => <ServiceCard key={index} service={service} index={index} />)}
        </div>
      </div>
    </section>;
}